import React, { useEffect, useRef, useState } from "react";
import { debounce } from "lodash";
import Tooltip from "@/Components/Tooltip";
import { Tag } from "@/Components/Tag";

const ShrinkableTagRow = ({ tags, showMinimumTags = 0 }) => {
  if (!tags) return null;

  const [hiddenTags, setHiddenTags] = useState(0);
  const rowRef = useRef(null);
  const tagRefs = useRef([]);

  const calculateTags = () => {
    const hiddenTagWidth = 45;
    let rowWidth = rowRef.current?.offsetWidth;
    let tagsWidth = 0;
    let hiddenCount = 0;

    tagRefs.current.forEach((ref, i) => {
      if (ref) {
        tagsWidth += ref.offsetWidth + 8;
        if (tagsWidth > rowWidth - hiddenTagWidth) {
          hiddenCount++;
        }
      }
    });

    if (tags.length - hiddenCount < showMinimumTags) {
      hiddenCount = tags.length - showMinimumTags;
    }

    setHiddenTags(hiddenCount);
  };

  useEffect(() => {
    tagRefs.current = tagRefs.current.slice(0, tags.length);
    calculateTags();
  }, [tags]);

  useEffect(() => {
    const debouncedHandleResize = debounce(() => {
      calculateTags();
    }, 50);

    window.addEventListener("resize", debouncedHandleResize);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  }, []);

  return (
    <div className="col-span-4 mb-2 flex md:col-span-3 md:mb-0" ref={rowRef}>
      <div className="flex max-w-full items-center gap-2">
        {tags &&
          tags.map((tag, i) => {
            let isHiddenTag = hiddenTags > 0 && i === tags.length - hiddenTags;
            // Get all the tags that are hidden
            let hiddenTagsNames = tags
              .slice(i, i + hiddenTags)
              .map((tag) => tag.name);

            return (
              <div
                className="flex-shrink-0"
                key={i}
                ref={(el) => (tagRefs.current[i] = el)}
                style={
                  i < tags.length - hiddenTags || isHiddenTag
                    ? { visibility: "visible" }
                    : { visibility: "hidden" }
                }
              >
                {isHiddenTag ? (
                  <Tooltip
                    tooltipText={hiddenTagsNames.join(", ")}
                    position="top"
                  >
                    <Tag margin="" className="h-8">
                      +{hiddenTags}
                    </Tag>
                  </Tooltip>
                ) : (
                  <Tag margin={""}>{tag.name}</Tag>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ShrinkableTagRow;
